export default __webpack_public_path__ + "static/brain-sad-7848b18f4f68be7c3a2546350ba5c0a9.png";